import { Icon, type IconName } from '../components/Icon'
import { Button } from '../components/Button'
import css from './LandingPage.module.css'

/**
 * Halaman perkenalan untuk tamu.
 *
 * Tetap berupa halaman perkenalan, bukan pengalihan langsung ke login —
 * sebagian pengunjung datang dari tautan berbagi dan perlu tahu lebih dulu
 * ini situs apa sebelum diminta memasukkan akun.
 */

const NILAI: { icon: IconName; judul: string; ket: string }[] = [
  {
    icon: 'share',
    judul: 'Bagikan tanpa batas ukuran',
    ket: 'Kirim satu tautan, penerima mengunduh langsung dari NAS — tanpa memecah berkas atau menumpang layanan luar.',
  },
  {
    icon: 'lock',
    judul: 'Akses yang bisa diatur',
    ket: 'Terbuka untuk umum, khusus yang sudah masuk, atau hanya NIJ tertentu. Permintaan akses ditinjau pemilik tautan.',
  },
  {
    icon: 'download',
    judul: 'Unduhan yang bisa dilanjutkan',
    ket: 'Terputus di tengah jalan tidak berarti mengulang dari awal. Bisa dipakai dengan pengelola unduhan.',
  },
]

export function LandingPage() {
  const masuk = () => {
    window.location.href = '/login?redirect=%2Fapp%2Fberanda'
  }

  return (
    <div className={css.halaman}>
      <header className={css.bar}>
        <span className={css.merek}>
          <span className={css.merekIkon}>
            <Icon name="drive" size={18} />
          </span>
          GMS Drive
        </span>
        <Button variant="secondary" onClick={masuk}>
          Masuk
        </Button>
      </header>

      <main className={css.utama}>
        <div className={css.cahaya} aria-hidden="true" />

        <h1 className={css.judul}>Berbagi berkas internal GMS Purwokerto</h1>
        <p className={css.sub}>
          Satu tempat untuk menyimpan, menemukan, dan membagikan berkas pelayanan — rekaman
          ibadah, dokumentasi, dan materi ministry — langsung dari penyimpanan gereja.
        </p>

        <div className={css.aksi}>
          <Button variant="primary" size="lg" onClick={masuk}>
            Masuk dengan MyGMS
          </Button>
        </div>

        <div className={css.nilai}>
          {NILAI.map((n) => (
            <div className={css.kartu} key={n.judul}>
              <span className={css.kartuIkon}>
                <Icon name={n.icon} size={20} />
              </span>
              <h2 className={css.kartuJudul}>{n.judul}</h2>
              <p className={css.kartuKet}>{n.ket}</p>
            </div>
          ))}
        </div>
      </main>

      <footer className={css.kaki}>
        Untuk staf dan relawan GMS Purwokerto. Masuk memakai akun MyGMS Anda.
      </footer>
    </div>
  )
}
